import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationFeedsComponent } from './notification-feeds/notification-feeds.component';
import { RequestFeedsComponent } from './request-feeds/request-feeds.component';
import { FeedsComponent } from './feeds.component';
import { FeedsRoutingModule } from "./feeds-routing.module";
import { PaginationModule, SdsActionsMenuModule, SdsPageModule,
  SdsSearchResultListModule, SdsSelectionPanelModule,
  SdsSideToolbarModule, SdsSideNavigationModule } from '@gsa-sam/components';
import { FormsModule } from '@angular/forms';
import { RequestSideNavComponent } from './request-feeds/request-side-nav/request-side-nav.component';
import { UsaAccordionModule } from '@gsa-sam/ngx-uswds';
import { RouterModule, Routes } from "@angular/router";
import { SdsFiltersModule } from '@gsa-sam/sam-formly';
import { SdsAgencyPickersModule, SharedFormlyModule } from '@gsa-sam/shared';
import { FormlyModule } from '@ngx-formly/core';
import { environment } from '../../../environments/environment';
import { RequestorSideComponent } from './request-feeds/requestor-side/requestor-side.component';
import { NotificationsFilterComponent } from './notification-feeds/notifications-filter/notifications-filter.component';

const routes: Routes = [
  { path: '', component: FeedsComponent }
];

@NgModule({
  declarations: [
    NotificationFeedsComponent,
    RequestFeedsComponent,
    FeedsComponent,
    RequestSideNavComponent,
    RequestorSideComponent,
    NotificationsFilterComponent
  ],
  imports: [
    CommonModule,
    FeedsRoutingModule,
    FormlyModule.forRoot(),
    FormsModule,
    PaginationModule,
    RouterModule.forChild(routes),
    SdsPageModule,
    SdsSelectionPanelModule,
    SdsSideNavigationModule,
    SdsSideToolbarModule,
    SdsFiltersModule,
    SharedFormlyModule,
    SdsAgencyPickersModule.forRoot({ environment: environment }),
    UsaAccordionModule,
    SdsActionsMenuModule,
    SdsSearchResultListModule
  ],
  providers: []
})
export class FeedsModule { }
